export const BRAND = {
  name: "Brett Weller",
  brokerage: "Keller Williams DTC",
  phone: "720-776-2502",
  phoneHref: "tel:7207762502",
  email: "Brett.Weller@kw.com",
  city: "Denver, Colorado",
  address: "6300 S. Syracuse Way #150, Englewood, CO 80111",
  headshot:
    "https://static.wixstatic.com/media/2aef16_00a32cddc4054c4ebf81ad13948471ad~mv2.jpg/v1/fill/w_792,h_802,fp_0.44_0.36,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/547973030_1139678541679602_3975498864635450925_n.jpg",
  social: {
    instagram: "https://www.instagram.com/brettweller_re/",
    facebook: "https://www.facebook.com/BrettWellerDenverRealtor/",
    linkedin: "https://www.linkedin.com/in/brett-weller92/",
  },
};

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1709689702529-6fa1f343e108?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  interior1:
    "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  interior2:
    "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const SYSTEM_STEPS = [
  {
    n: "01",
    title: "Position Your Home to Win",
    text:
      "We prepare and price your home strategically — not just to sell, but to attract multiple qualified buyers competing for it. This isn't about getting lucky. It's about being ready.",
  },
  {
    n: "02",
    title: "Create Concentrated Demand",
    text:
      "Instead of trickling showings over months, we launch your home to create a surge of buyer interest in a compressed window. More buyers at once means competition — and competition drives prices up.",
  },
  {
    n: "03",
    title: "Leverage for Better Offers",
    text:
      "With multiple interested buyers, you're in the driver's seat. We use that demand to negotiate stronger offers, better terms, and a closing timeline that works for you.",
  },
];

export const STATS = [
  { value: "Top $", label: "Strategy built to maximize your sale price" },
  { value: "Days", label: "Sold in days, not months on market" },
  { value: "Zero", label: "Guesswork — a proven, repeatable plan" },
];

export const TESTIMONIALS = [
  {
    name: "Amy S.",
    text:
      "As first-time buyers, we were nervous, but Brett made everything easy and stress-free. Patient, transparent, and always available. He went above and beyond to make sure we found the perfect home.",
  },
  {
    name: "Craig G.",
    text:
      "Brett's attention to detail and commitment are exceptional. He found us a stunning home in Hilltop that checked every box. From negotiation to closing, his service was white-glove all the way.",
  },
  {
    name: "Brian W.",
    text:
      "Brett took the time to understand exactly what I was looking for and made the entire process smooth. Always responsive, honest, and went above and beyond. A truly top-tier Realtor who cares.",
  },
];

export const SERVICES = [
  {
    tag: "For Sellers",
    title: "Sell for top dollar, on your timeline.",
    text:
      "Proven pricing and modern marketing strategies — premium photography, high-impact listing presentation, and concentrated digital reach — engineered to maximize your home's value with the least stress.",
    points: ["Strategic pricing & prep", "Concentrated demand launch", "Expert negotiation & terms"],
    image: IMAGES.interior2,
  },
  {
    tag: "For Buyers",
    title: "Find the right home with confidence.",
    text:
      "Step-by-step support to make smart, stress-free decisions in Denver's fast-moving market — from first showing to closing table, with local expertise guiding every step.",
    points: ["Local market insight", "Data-driven offers", "Smooth path to closing"],
    image: IMAGES.interior1,
  },
];
